module.exports = {
  eventCategory: 'Editor UI | Tool Menu | templates',

  addEvent: function (event) {
    var isEmpty = $('#svgroot .main').find(':not(title)').length === 0;
    var requireNewPage = !this.isSameSize() && !isEmpty;

    (requireNewPage || isEmpty) && this.trackEvent({
      eventAction: 'add_' + (this.design ? 'designed' : 'grid'),
      eventLabel: requireNewPage ? 'new_page' : 'current_empty_page'
    });
  },

  acceptModal: function (event) {
    this.trackEvent({
      eventAction: 'add_' + (this.design ? 'designed' : 'grid'),
      eventLabel: 'current_page'
    });
  },

  closeModal: { eventAction: 'cancel_adding' }
};
